// extracted by mini-css-extract-plugin
export default {"card":"Card_card__0McnJ","header":"Card_header__HXS0T"};